import { useContext } from "react";
import { TargetsUploaderContext } from "components/product-collection/footer/components/left-side/add-target-values/targets-uploader-context";

export const useTargetsUploader = () => useContext(TargetsUploaderContext);
